<!-- The first thing a new person sees. Factory-owned. Styles in kit.css.

     Art, a heading that names the SITUATION, one line saying what to do about
     it, and the control that does it. A sentence on its own is a shrug.

     The art slot takes an illustration (`<template #art><img …></template>`);
     without one, `icon` is drawn large on a soft accent disc so the state is
     never a bare paragraph. Actions go in the default slot. -->
<template>
  <section class="kit-empty" role="status">
    <div class="kit-empty__art" aria-hidden="true">
      <slot name="art">
        <IonIcon v-if="icon" :icon="icon" />
      </slot>
    </div>
    <h2 class="kit-empty__title">{{ title }}</h2>
    <p v-if="body" class="kit-empty__body">{{ body }}</p>
    <div v-if="$slots.default" class="kit-empty__actions">
      <slot />
    </div>
  </section>
</template>

<script setup>
import { IonIcon } from '@ionic/vue';

defineProps({
  title: { type: String, required: true },
  body: { type: String, default: '' },
  icon: { type: String, default: '' },
});
</script>
